import { render, staticRenderFns } from "./SpaceSelectorModal.vue?vue&type=template&id=2f4a9d31&"
import script from "./SpaceSelectorModal.vue?vue&type=script&lang=js&"
export * from "./SpaceSelectorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports